export default __webpack_public_path__ + "static/media/030_corner_veryclose.af73153b.mp3";